<template>
  <div data-bank-details-wrapper>
    <bank-details-form :error-in-bank-details="errorInBankDetails" />
  </div>
</template>

<script>
import BankDetailsForm from "@/components/BankDetails.vue";

export default {
  name: "BankDetails",
  props: {
    errorInBankDetails: {
      default: false,
      required: false,
    },
  },
  components: {
    BankDetailsForm,
  },
};
</script>
